import { APP_INITIALIZER, LOCALE_ID } from '@angular/core';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';

export function appInit(i18next: ITranslationService) {
  return () =>
    i18next.init({
      supportedLngs: ['pt-PT', 'es-ES'],
      fallbackLng: 'es-ES',
      lng: i18next.language || sessionStorage.getItem('i18nlang') || 'es-ES',
      debug: false,
      returnEmptyString: false,
      ns: ['translation', 'validation', 'error'],
      resources: {
        'es-ES': {
          translation: require('../../../../i18n/es.json')
        },
        'pt-PT': {
          translation: require('../../../../i18n/pt.json')
        }
      }
    });
}

export function localeIdFactory(i18next: ITranslationService) {
  return i18next.language;
}

export const I18N_PROVIDERS = [
  {
    provide: APP_INITIALIZER,
    useFactory: appInit,
    deps: [I18NEXT_SERVICE],
    multi: true
  },
  {
    provide: LOCALE_ID,
    deps: [I18NEXT_SERVICE],
    useFactory: localeIdFactory
  }
];
